const t = {
  name: "BankPayout",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 7.58984V0H11V7.59015L8.49984 5.09L7.08984 6.5L11.9998 11.41L16.9098 6.5L15.4998 5.09L13 7.58984Z" fill="currentColor"/>
<path d="M19 15V22H22V24H2V22H5V15H2V11.59L5 8.59L6.41 10L4 12.41V13H20V12.41L17.59 10L19 8.59L22 11.59V15H19ZM7 22H9V15H7V22ZM11 22H13V15H11V22ZM15 22H17V15H15V22Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as BankPayout
};
